import { render, staticRenderFns } from "./BpApproveDecline.vue?vue&type=template&id=6dc44328&scoped=true"
import script from "./BpApproveDecline.vue?vue&type=script&lang=js"
export * from "./BpApproveDecline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc44328",
  null
  
)

export default component.exports